import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { UserNotificationSettings } from '@app/models/users';
import Api from '@app/services/api';

interface IProps {
  data: UserNotificationSettings;
  id: string;
}

export const useUpdateUserNotifications = () => {
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, id }: IProps) => {
      return await Api.users.putSettingsNotifications(id, data);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
  });
};
